module.exports = "../assets/comingsoon-placeholder.c5415068.png";